import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  FinancialPeriodDto,
  FinancialPeriodListDto,
  FinancialPeriodFilterDto,
  CreateFinancialPeriodRequest,
  UpdateFinancialPeriodRequest,
} from '@/types/financialPeriod.types';

export const financialPeriodApi = {
  /** GET /api/v1/financial-periods — paginated list with optional search/filter */
  getList: (filter?: FinancialPeriodFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<FinancialPeriodListDto>>>('/financial-periods', {
      params: filter,
    }),

  /** GET /api/v1/financial-periods/{id} — full financial period record */
  getById: (id: string) =>
    apiClient.get<ApiResponse<FinancialPeriodDto>>(`/financial-periods/${id}`),

  /** GET /api/v1/financial-periods/by-code/{code} — returns 404 when not found */
  getByCode: (code: string) =>
    apiClient.get<ApiResponse<FinancialPeriodDto>>(
      `/financial-periods/by-code/${encodeURIComponent(code)}`,
    ),

  /** POST /api/v1/financial-periods — create a new financial period */
  create: (data: CreateFinancialPeriodRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/financial-periods', data),

  /** PUT /api/v1/financial-periods/{id} — update financial period details */
  update: (id: string, data: UpdateFinancialPeriodRequest) =>
    apiClient.put<ApiResponse<object>>(`/financial-periods/${id}`, data),

  /** DELETE /api/v1/financial-periods/{id} — soft-delete the financial period */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/financial-periods/${id}`),

  /** POST /api/v1/financial-periods/{id}/close — close the financial period */
  close: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/financial-periods/${id}/close`),

  /** POST /api/v1/financial-periods/{id}/reopen — reopen the financial period */
  reopen: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/financial-periods/${id}/reopen`),
};
